// ============================================================
// Adelaide suburb → region map.
//
// Used by compoundIntent.js to detect ANY common Adelaide
// suburb in a search query, even if we don't have a dedicated
// /building-in/<slug> page for it yet. Suburbs without a
// dedicated page route to their region's "home builders"
// landing page as a sensible fallback.
//
// Curated rather than scraped - covers the ~150 Adelaide
// suburbs most commonly searched for in residential building
// queries (greenfield growth corridors, established suburbs,
// hills townships and beach suburbs).
//
// Add a new suburb? One line. Region must match a key in
// REGION_ROUTES inside compoundIntent.js.
// ============================================================

export const ADELAIDE_SUBURBS = {
  // ── Northern Adelaide ────────────────────────────────────
  'Andrews Farm':     'Northern Adelaide',
  'Angle Vale':       'Northern Adelaide',
  'Blakeview':        'Northern Adelaide',
  'Buckland Park':    'Northern Adelaide',
  'Burton':           'Northern Adelaide',
  'Craigmore':        'Northern Adelaide',
  'Davoren Park':     'Northern Adelaide',
  'Direk':            'Northern Adelaide',
  'Edinburgh North':  'Northern Adelaide',
  'Eyre':             'Northern Adelaide',
  'Gawler':           'Northern Adelaide',
  'Gawler East':      'Northern Adelaide',
  'Hillbank':         'Northern Adelaide',
  'Mawson Lakes':     'Northern Adelaide',
  'Munno Para':       'Northern Adelaide',
  'Munno Para West':  'Northern Adelaide',
  'Para Hills':       'Northern Adelaide',
  'Paralowie':        'Northern Adelaide',
  'Penfield':         'Northern Adelaide',
  'Salisbury':        'Northern Adelaide',
  'Salisbury East':   'Northern Adelaide',
  'Salisbury North':  'Northern Adelaide',
  'Salisbury Plain':  'Northern Adelaide',
  'Smithfield':       'Northern Adelaide',
  'Two Wells':        'Northern Adelaide',
  'Virginia':         'Northern Adelaide',
  'Walkley Heights':  'Northern Adelaide',
  'Roseworthy':       'Northern Adelaide',
  'Elizabeth':        'Northern Adelaide',
  'Elizabeth Vale':   'Northern Adelaide',
  'Elizabeth Park':   'Northern Adelaide',
  'Elizabeth Downs':  'Northern Adelaide',

  // ── Eastern / Inner Adelaide ─────────────────────────────
  'Magill':           'Eastern Adelaide',
  'Norwood':          'Eastern Adelaide',
  'Burnside':         'Eastern Adelaide',
  'Toorak Gardens':   'Eastern Adelaide',
  'Beulah Park':      'Eastern Adelaide',
  'Stepney':          'Eastern Adelaide',
  'Kensington':       'Eastern Adelaide',
  'Kensington Park':  'Eastern Adelaide',
  'Kensington Gardens':'Eastern Adelaide',
  'Marryatville':     'Eastern Adelaide',
  'St Peters':        'Eastern Adelaide',
  'College Park':     'Eastern Adelaide',
  'Hectorville':      'Eastern Adelaide',
  'Campbelltown':     'Eastern Adelaide',
  'Newton':           'Eastern Adelaide',
  'Paradise':         'Eastern Adelaide',
  'Tranmere':         'Eastern Adelaide',
  'Rostrevor':        'Eastern Adelaide',
  'Athelstone':       'Eastern Adelaide',
  'Tea Tree Gully':   'Eastern Adelaide',
  'Modbury':          'Eastern Adelaide',
  'Modbury North':    'Eastern Adelaide',
  'Modbury Heights':  'Eastern Adelaide',
  'Golden Grove':     'Eastern Adelaide',
  'Greenwith':        'Eastern Adelaide',
  'Wynn Vale':        'Eastern Adelaide',
  'Surrey Downs':     'Eastern Adelaide',
  'Highbury':         'Eastern Adelaide',
  'Houghton':         'Eastern Adelaide',

  // ── Inner Adelaide ───────────────────────────────────────
  'Adelaide':         'Inner Adelaide',
  'North Adelaide':   'Inner Adelaide',
  'Unley':            'Inner Adelaide',
  'Unley Park':       'Inner Adelaide',
  'Hyde Park':        'Inner Adelaide',
  'Wayville':         'Inner Adelaide',
  'Goodwood':         'Inner Adelaide',
  'Parkside':         'Inner Adelaide',
  'Eastwood':         'Inner Adelaide',
  'Frewville':        'Inner Adelaide',
  'Glenside':         'Inner Adelaide',
  'Glen Osmond':      'Inner Adelaide',
  'Mile End':         'Inner Adelaide',
  'Thebarton':        'Inner Adelaide',
  'Hilton':           'Inner Adelaide',
  'Cowandilla':       'Inner Adelaide',
  'Torrensville':     'Inner Adelaide',

  // ── Western Adelaide ─────────────────────────────────────
  'Henley Beach':     'Western Adelaide',
  'Henley Beach South':'Western Adelaide',
  'Glenelg':          'Western Adelaide',
  'Glenelg North':    'Western Adelaide',
  'Glenelg East':     'Western Adelaide',
  'Glenelg South':    'Western Adelaide',
  'Brighton':         'Western Adelaide',
  'North Brighton':   'Western Adelaide',
  'Hove':             'Western Adelaide',
  'Somerton Park':    'Western Adelaide',
  'Seacliff':         'Western Adelaide',
  'Marino':           'Western Adelaide',
  'Kingston Park':    'Western Adelaide',
  'Grange':           'Western Adelaide',
  'Tennyson':         'Western Adelaide',
  'Semaphore':        'Western Adelaide',
  'West Lakes':       'Western Adelaide',
  'Royal Park':       'Western Adelaide',
  'Findon':           'Western Adelaide',
  'Fulham':           'Western Adelaide',
  'Fulham Gardens':   'Western Adelaide',
  'Lockleys':         'Western Adelaide',
  'West Beach':       'Western Adelaide',
  'Plympton':         'Western Adelaide',
  'Plympton Park':    'Western Adelaide',
  'Park Holme':       'Western Adelaide',
  'Glenelg Jetty Road':'Western Adelaide',
  'Greenacres':       'Western Adelaide',
  'Woodville':        'Western Adelaide',
  'Pennington':       'Western Adelaide',
  'Cheltenham':       'Western Adelaide',
  'Port Adelaide':    'Western Adelaide',
  'Largs Bay':        'Western Adelaide',
  'Largs North':      'Western Adelaide',
  'Outer Harbor':     'Western Adelaide',
  'North Haven':      'Western Adelaide',
  'Taperoo':          'Western Adelaide',

  // ── Southern Adelaide ────────────────────────────────────
  'Hallett Cove':     'Southern Adelaide',
  'Trott Park':       'Southern Adelaide',
  'Sheidow Park':     'Southern Adelaide',
  'Reynella':         'Southern Adelaide',
  'Reynella East':    'Southern Adelaide',
  'Old Reynella':     'Southern Adelaide',
  'Morphett Vale':    'Southern Adelaide',
  'Hackham':          'Southern Adelaide',
  'Hackham West':     'Southern Adelaide',
  'Christies Beach':  'Southern Adelaide',
  'Christies Downs':  'Southern Adelaide',
  'Noarlunga Centre': 'Southern Adelaide',
  'Noarlunga Downs':  'Southern Adelaide',
  'Port Noarlunga':   'Southern Adelaide',
  'Port Noarlunga South':'Southern Adelaide',
  'Seaford':          'Southern Adelaide',
  'Seaford Heights':  'Southern Adelaide',
  'Seaford Meadows':  'Southern Adelaide',
  'Seaford Rise':     'Southern Adelaide',
  'Aldinga':          'Southern Adelaide',
  'Aldinga Beach':    'Southern Adelaide',
  'Maslin Beach':     'Southern Adelaide',
  'Willunga':         'Southern Adelaide',
  'McLaren Vale':     'Southern Adelaide',
  'Sellicks Beach':   'Southern Adelaide',
  'Mount Compass':    'Southern Adelaide',
  'Goolwa':           'Southern Adelaide',
  'Victor Harbor':    'Southern Adelaide',
  'Strathalbyn':      'Southern Adelaide',

  // ── Adelaide Hills ───────────────────────────────────────
  'Mount Barker':     'Adelaide Hills',
  'Stirling':         'Adelaide Hills',
  'Aldgate':          'Adelaide Hills',
  'Crafers':          'Adelaide Hills',
  'Crafers West':     'Adelaide Hills',
  'Bridgewater':      'Adelaide Hills',
  'Hahndorf':         'Adelaide Hills',
  'Heathfield':       'Adelaide Hills',
  'Mylor':            'Adelaide Hills',
  'Macclesfield':     'Adelaide Hills',
  'Lobethal':         'Adelaide Hills',
  'Woodside':         'Adelaide Hills',
  'Verdun':           'Adelaide Hills',
  'Echunga':          'Adelaide Hills',
  'Nairne':           'Adelaide Hills',
  'Littlehampton':    'Adelaide Hills',
  'Birdwood':         'Adelaide Hills',
  'Mount Pleasant':   'Adelaide Hills',
  'Belair':           'Adelaide Hills',
  'Blackwood':        'Adelaide Hills',
  'Eden Hills':       'Adelaide Hills',
  'Coromandel Valley':'Adelaide Hills',
  'Bellevue Heights': 'Adelaide Hills',
};
